import { render } from "./Home.vue?vue&type=template&id=bb5d1b3a"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=bb5d1b3a&lang=css"

import exportComponent from "C:\\laragon\\www\\ofira-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__